export * from './fireblocksAssetBalanceController.service';
import { FireblocksAssetBalanceControllerService } from './fireblocksAssetBalanceController.service';
export * from './fireblocksVaultSettingController.service';
import { FireblocksVaultSettingControllerService } from './fireblocksVaultSettingController.service';
export * from './fireblocksVaultTransferController.service';
import { FireblocksVaultTransferControllerService } from './fireblocksVaultTransferController.service';
export * from './integrationController.service';
import { IntegrationControllerService } from './integrationController.service';
export * from './vaultController.service';
import { VaultControllerService } from './vaultController.service';
export const APIS = [
  FireblocksAssetBalanceControllerService,
  FireblocksVaultSettingControllerService,
  FireblocksVaultTransferControllerService,
  IntegrationControllerService,
  VaultControllerService,
];
